module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CAszOu/tc-custom/9780544464933.jpg?1734289669212",
      "alt": "This image is the cover for the book Suspicious River"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Suspicious River\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Those who like Joyce Carol Oates will love this” dark novel of psychological suspense by the author of "), _c('i', [_vm._v("Mind of Winter")]), _vm._v(" and "), _c('i', [_vm._v("The Life Before Her Eyes")]), _vm._v(" ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A married motel receptionist in a bleak Michigan town, Leila Murray has slipped into the habit of trading sex with strangers for money. When she meets a drifter who alternately sweet-talks and physically abuses her, it might be the wakeup call that dissuades her from a life of prostitution. Instead, she allows him to become her pimp."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In this chilling, “beautifully written page-turner” ("), _c('i', [_vm._v("Booklist")]), _vm._v("), we follow Leila’s life as she spirals out of control—and learn the darkness in her past that drives her—in “an exploration of the legacy of abuse and violence [and] an amazing first novel” ("), _c('i', [_vm._v("The Boston Globe")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[An] extremely powerful debut . . . Profoundly disturbing but also resonant with hope and rebirth.” —"), _c('i', [_vm._v("Los Angeles Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Kasischke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laura Kasischke is the author of two novels and three collections of poetry. Her numerous awards include the Alice Fay DiCastagnola Award from the Poetry Society of America and the Bobst Award for Emerging Writers. She lives in Chelsea, Michigan.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0